import { Badge, BadgeSize, BadgeVariant, Show } from "shared/components";
import { DeclineConditions } from "./DeclineConditions";
import { VerticalSpacer } from "shared/app/VerificationTemplate/slices/DecisionCriteria/slices/RuleCriteria/components/VerticalSpacer";
import { ApprovalConditions } from "./ApprovalConditions";
import { Application } from "types/application";
import { Card } from "shared/components/Card";
import FailedIcon from "shared/icons/status-icons/fail-icon.svg?react";

export const FullBreakdown = ({
  application,
  isMetDeclineConditions,
  isMetApprovalConditions
}: {
  application: Application;
  isMetDeclineConditions: boolean;
  isMetApprovalConditions: boolean;
}) => {
  return (
    <div className="px-6 pt-6 pb-6 border-t border-alpha-40 bg-background-900">
      <DeclineConditions application={application} />

      <Show if={!isMetDeclineConditions}>
        <VerticalSpacer height={24} className="ml-[118px]" />
        <Badge className="ml-4" variant={BadgeVariant.BASE} size={BadgeSize.SM}>
          Conditions for decline weren&apos;t met
        </Badge>
        <VerticalSpacer height={24} className="ml-[118px]" />
        <ApprovalConditions application={application} />
      </Show>

      <Show if={!isMetDeclineConditions && !isMetApprovalConditions}>
        <VerticalSpacer height={24} className="ml-[118px]" />
        <Badge className="ml-4" variant={BadgeVariant.BASE} size={BadgeSize.SM}>
          Conditions for approval weren&apos;t met
        </Badge>
        <VerticalSpacer height={24} className="ml-[118px]" />
        <Card>
          <div className="px-6 py-4 flex items-center gap-2">
            <FailedIcon className="w-5 text-warning-500" />
            <h2 className="text-base font-bold text-content-1000">
              Recommended conditional approval
            </h2>
          </div>
        </Card>
      </Show>
    </div>
  );
};
